/** Every string the authoring route adds on top of the shared editor. */
export const copy = {
  crumbs: {
    root: 'لوحة التشغيل',
    list: 'المقالات',
    current: 'مقال جديد',
  },

  head: {
    title: 'مقال جديد',
    lede: 'اكتب في العمود، واضبط في الجانب. الجسم يُخزَّن شجرةَ كتل — لكلّ كتلة نوعٌ ومحتواها — فما يُحفَظ بنيةٌ يقرأها العارض، لا وسوم صفحة.',
  },

  /** Draft is the only state a new post can hold; no control offers another. */
  stateHint:
    'يبدأ كلّ مقال مسوّدةً يراها كاتبه وحده. حين ترفعه للمراجعة ينتقل إلى مراجِع — وهو من ينشره أو يردّه، لا أنت.',

  publishNotice: {
    title: 'النشر بيد مراجِع',
    body: 'لا يصل مقالٌ إلى القرّاء بيدٍ واحدة: كاتبه يرفعه، ومراجِعٌ غيره ينشره.',
  },

  announce: (title: string) => `حُفظ «${title}» مسوّدةً.`,
} as const;
